import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const locationImporterSelectors = importerSelectors(
  'location.importer',
);

export default locationImporterSelectors;
